import { createFileRoute } from "@tanstack/react-router";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { TicketTypeLifecycleSection } from "./fullLifecycle";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/lifecycle",
)({
	component: AdminTicketTypeLifecycleTab,
});

function AdminTicketTypeLifecycleTab() {
	const { ticketType } = useTicketTypeDrawerContext();

	return (
		<div className="px-5 pb-5">
			<TicketTypeLifecycleSection ticketType={ticketType} scope="platform" />
		</div>
	);
}
